export const getDurationInYears = (startYear: number, endYear?: number) =>
  endYear ? endYear - startYear + 1 : 1
